import { UseFilePickerConfig, Validator } from 'use-file-picker';
import { FileWithPath } from 'file-selector';
import { FileService } from '../../services/v1/security/FileService';
import { ApiError } from '../../services/ApiService/errors/ApiError';

export const MaliciousFileContentError = 'maliciousFileContentError';

export class VirusScanValidator implements Validator {
  validateBeforeParsing(_config: UseFilePickerConfig, _plainFiles: File[]) {
    return Promise.resolve();
  }

  validateAfterParsing(
    _config: UseFilePickerConfig,
    file: FileWithPath,
    _reader: FileReader,
  ) {
    return new Promise<void>((res, rej) => {
      FileService.virusScan(file)
        .then((_) => res())
        .catch((_: ApiError) =>
          rej({
            name: MaliciousFileContentError,
            reason: 'File contains suspicious content',
          }),
        );
    });
  }
}
